import { Tabs } from '@chakra-ui/react'
import { useAsyncValue } from 'react-router-dom'

import OrganizationForm from './components/organizationForm'

import SsoForm from '@app/pages/settings/organization/components/ssoForm'
import GatedFeature from '@app/shared/gatedFeature'
import { PageStack } from '@app/shared/layout'
import withAwait from '@app/shared/withAwait'
import type { Organization } from '@graphql/queries'

export const Edit = () => {
  const organization = useAsyncValue() as Organization

  return (
    <PageStack>
      <Tabs.Root defaultValue="general">
        <Tabs.List>
          <Tabs.Trigger value="general">General</Tabs.Trigger>
          <GatedFeature featureId="feature-sso">
            {({ entitlement }) => {
              if (!entitlement) {
                return null
              }

              if (entitlement && !entitlement.hasAccess) {
                return null
              }
              return <Tabs.Trigger value="sso">SSO</Tabs.Trigger>
            }}
          </GatedFeature>
        </Tabs.List>
        <Tabs.Content value="general">
          <OrganizationForm organization={organization} />
        </Tabs.Content>
        <Tabs.Content value="sso">
          <SsoForm organization={organization} />
        </Tabs.Content>
      </Tabs.Root>
    </PageStack>
  )
}

export default withAwait(Edit, 'organization')
